var process = require("../shim/process.js");
const config = require("../config.js");
const Terrain = require("../libs/Terrain.js");
const Zone = require("../libs/Zone.js");
const weapons = require("./weapons.js");
const store = require("./store.js");
const triggers = require("./triggers.js");
const gameModes = require("./gameModes.js");
var prefabs = new (require("./prefabs.js"))();
const GameObject = require("../libs/GameObject.js");
const sentry = require("../shim/sentry.js");
var {
  Triangle,
  Vector3
} = require("three");
const UTILS = require("../libs/utils.js");
Triangle.fromConfig = function (config) {
  var v12621 = new Triangle(new Vector3(config.tris[0], config.tris[1], config.tris[2]), new Vector3(config.tris[3], config.tris[4], config.tris[5]), new Vector3(config.tris[6], config.tris[7], config.tris[8]));
  v12621.isTri = true;
  v12621.minX = config.minMax[0];
  v12621.minY = config.minMax[1];
  v12621.minZ = config.minMax[2];
  v12621.maxX = config.minMax[3];
  v12621.maxY = config.minMax[4];
  v12621.maxZ = config.minMax[5];
  return v12621;
};
var vA695 = [0, 2, 3, 19, 25];
module.exports = function (p15649, p15650, PARTICLES, p15652) {
  this.manager = new (require("../libs/MapManager.js"))(p15650, p15652, prefabs);
  this.maps = p15649;
  this.modes = gameModes;
  this.rotationModes = vA695;
  this.rotationMaps = [0, 1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 19, 21, 22, 23, 24, 25, 26, 28];
  this.spawns = [];
  this.lastGen = null;
  this.terrain = null;
  this.zone = null;
  this.deathY = config.deathY;
  this.changedMaps = false;
  var v12622;
  var v12623;
  this.resetMaps = function () {
    this.changedMaps = false;
    this.maps = p15649;
  };
  this.setMaps = function (p15653) {
    if (p15653) {
      this.changedMaps = true;
    }
    this.maps = p15653 || p15649;
  };
  this.getRandomMap = function () {
    return UTILS.randInt(0, this.maps.length - 1);
  };
  this.getMapName = function () {
    var v12624 = (this.lastGen || "").split("_")[0];
    if (this.maps && this.maps[v12624] && this.maps[v12624].name) {
      return this.maps[v12624].name;
    } else {
      return null;
    }
  };
  this.getMapId = function () {
    var v12625 = (this.lastGen || "").split("_")[0];
    if (this.maps && this.maps[v12625]) {
      return v12625;
    } else {
      return null;
    }
  };
  this.asyncGenerate = function (p15654, p15655, p15656, p15657, p15658, p15659) {
    var v12626 = gameModes[p15655 || 0];
    if (!this.workerPath) {
      this.workerPath = process.cwd() + (config.isProd ? "/dist/mapWorker.js" : "/src/data/mapWorker.js");
    }
    if (!this.Worker) {
      this.Worker = eval("require;")("worker_threads").Worker;
    }
    return new Promise((p15660, p15661) => {
      var vIi38 = f2099(p15654, v12626, p15656);
      if (!p15657 && this.lastGen === vIi38) {
        this.finishGenerate(p15656);
        p15660();
        return;
      }
      var v12634;
      var v12636 = false;
      let vF101 = p15662 => {
        if (p15662 && p15662.__error) {
          throw new Error(p15662.__error.message || "map worker failed");
        }
        var vO403 = {
          mapObjects: {}
        };
        var vA696 = [];
        for (var v12627 in p15662._ctx.mapObjects) {
          var v12631 = p15662._ctx.mapObjects[v12627];
          var v12632 = new GameObject(v12631, parseInt(v12627), false);
          vO403.mapObjects[v12627] = v12632;
          for (var v12633 of config.mapObjectReferenceProps) {
            if (typeof v12631[v12633] == "number") {
              vA696.push(v12627, v12633);
            }
          }
        }
        for (var vLN02257 = 0; vLN02257 < vA696.length; vLN02257 += 2) {
          var v12631 = p15662._ctx.mapObjects[vA696[vLN02257]];
          var v12632 = vO403.mapObjects[vA696[vLN02257]];
          var v12633 = vA696[vLN02257 + 1];
          v12632[v12633] = vO403.mapObjects[v12631[v12633]];
        }
        f2097(vO403, p15662, config.mapGenProps, this);
        v12636 = true;
        p15660(v12634);
      };
      let vF102 = p15663 => {
        if (v12636) {
          return;
        }
        sentry.warn("Falling back to sync map generation", {
          err: p15663 + ""
        });
        try {
          this.generate(p15654, p15655, p15656, p15657, p15658, p15659, true);
          v12636 = true;
          p15660(v12634);
        } catch (e168) {
          v12636 = true;
          p15661(e168);
        }
      };
      var vO404 = {
        generate: {
          index: p15654,
          modeIndex: p15655,
          eventIndex: p15656,
          force: p15657,
          isCustom: p15658,
          isComp: p15659
        }
      };
      if (this.changedMaps || p15658) {
        vO404.maps = this.maps;
      }
      v12634 = new this.Worker(this.workerPath, {
        workerData: JSON.stringify(vO404)
      });
      v12634.on("message", p15663 => {
        try {
          vF101(JSON.parse(p15663));
        } catch (e168) {
          vF102(e168);
          return;
        }
      });
      v12634.on("error", p15664 => {
        sentry.warn("Error from map worker", {
          err: p15664 + ""
        });
        vF102(p15664);
      });
      v12634.on("exit", p15665 => {
        if (p15665 !== 0 && !v12636) {
          vF102("Worker stopped with exit code " + p15665);
        }
      });
    });
  };
  var vLS114 = "";
  this.generate = function (p15666, p15667, p15668, p15669, p15670, p15671, p15672) {
    var v12635 = this.maps[p15666];
    v12635.game = v12635.game || {};
    var v12636 = gameModes[p15667 || 0];
    this.deathY = v12635.dthY != null && UTILS.isNumber(v12635.dthY) ? v12635.dthY : config.deathY;
    if (p15650) {
      var v12637 = !!p15670;
      var v12638 = this.maps[p15666];
      if (v12638) {
        v12637 = p15666 == 0 && v12638.name != "Burg";
      }
      p15650.groupData = {
        id: v12635.id,
        hasLM: v12635.hasLM,
        version: 0,
        index: p15666,
        custom: v12637,
        official: v12635.official
      };
      if (v12635 && v12635.oldAO) {
        p15650.groupData.oldAO = true;
      }
      mapInfo.textContent = (v12637 ? v12636.alias : v12636.name) + " on " + v12635.name;
      mapInfo.classList.toggle("click", !!v12635.creator);
      mapInfo.onclick = v12635.creator ? () => window.openURL("/social.html?p=map&q=" + v12635.name) : null;
      gameMessage.innerHTML = specGMessage.innerHTML = "";
      roundMessage.innerHTML = "";
      matchInfo.innerHTML = v12636.name + "<div style='color:rgba(255,255,255,0.6)'>on " + v12635.name + "</div>" + (v12635.creator ? "<div style='color:#fff'><span style='color:rgba(255,255,255,0.6)'>by</span> " + v12635.creator + "</div>" : "");
      specGameInfo.textContent = v12636.name;
    }
    if (p15650 && vLS114 != v12635.welMsg) {
      vLS114 = v12635.welMsg;
      if (vLS114 && vLS114 != "") {
        welcome(vLS114);
      }
    }
    var vIi39 = f2099(p15666, v12636, p15668);
    if (p15669 || this.lastGen !== vIi39) {
      this.lastGen = vIi39;
      if (p15650) {
        p15650.clearInstances();
      }
      this.manager.removeAll();
      if (p15650) {
        p15650.init(v12635, v12636, undefined, p15668);
      }
      if (PARTICLES) {
        PARTICLES.reset();
        p15650.scene.add(PARTICLES.ExplosionManager);
      }
      if (p15652) {
        p15652.clearEmitters();
      }
      if (!v12635.terrainSeed || !v12635.terrainWidth || !v12635.terrainHeight) {
        this.terrain = null;
      } else {
        this.terrainConfig = UTILS.extractProperties(v12635, Terrain.CONFIG_PROPS);
        this.terrain = Terrain.fromConfig(this.terrainConfig);
        this.terrain.rotation.x = -Math.PI / 2;
        if (p15650) {
          p15650.scene.add(this.terrain);
        }
        if (this.terrain.genObjs) {
          for (var v12639 in this.terrain.objPos) {
            if (this.terrain.objPos.hasOwnProperty(v12639)) {
              for (var vLN02278 = 0; vLN02278 < this.terrain.objPos[v12639].length; vLN02278++) {
                this.manager.addTerrObj(this.terrain.objPos[v12639][vLN02278], v12639, this.terrain, PARTICLES);
              }
            }
          }
          this.terrain.objPos = null;
        }
      }
      if (v12635.zone && v12635.zoneSize && v12635.zoneSpeed) {
        this.zoneConfig = UTILS.extractProperties(v12635, Zone.CONFIG_PROPS);
        this.zone = Zone.fromConfig(this.zoneConfig, p15650);
        if (p15650) {
          p15650.scene.add(this.zone);
        }
      } else {
        this.zone = null;
      }
      var vLN02259 = 0;
      var vLN02260 = 0;
      var vLN02261 = 0;
      var vLN02262 = 0;
      var vLN02263 = 0;
      var vLN02264 = 0;
      var v12640 = v12635.colors || [];
      var vA697 = ["e", "c"];
      var v12641 = v12635.xyz || [];
      var vA698 = ["s"];
      for (var vLN02278 = 0; vLN02278 < v12635.objects.length; ++vLN02278) {
        v12622 = v12635.objects[vLN02278];
        var v12642 = (prefabs.prefabs[v12622.i || v12622.id || 0] || prefabs.prefabs[0]).name;
        var v12643 = v12642 == "LADDER" || v12642 == "ROPE_LADDER";
        var v12644 = (prefabs.textures[v12622.t == null ? v12643 ? 2 : 0 : v12622.t || 0] || prefabs.textures[v12643 ? 2 : 0]).name;
        var vParseInt47 = parseInt(v12622.sat || 0);
        for (var v12664 = 0; v12664 < vA698.length; v12664++) {
          if (v12622[vA698[v12664] + "i"] != null) {
            var v12645 = v12622[vA698[v12664] + "i"] * 3;
            if (v12622[vA698[v12664] + "i"] != null && v12645 != null && v12641.length > v12645) {
              v12622[vA698[v12664]] = v12641.slice(v12645, v12645 + 3);
              delete v12622[vA698[v12664] + "i"];
            }
          }
        }
        if (!p15672 && v12622.f && typeof v12622.f == "string") {
          try {
            v12622.f = UTILS.convertFaces(v12622.f);
          } catch (e169) {
            v12622.f = null;
          }
        } else if (p15672) {
          v12622.f = null;
        }
        if (!p15672) {
          for (var v12664 = 0; v12664 < vA697.length; v12664++) {
            if (v12622[vA697[v12664] + "i"] != null && v12640[v12622[vA697[v12664] + "i"]]) {
              v12622[vA697[v12664]] = v12640[v12622[vA697[v12664] + "i"]];
              delete v12622[vA697[v12664] + "i"];
            }
          }
        }
        var v12646;
        var v12647 = UTILS.limit(v12622.p[0], config.positionRange).round(2);
        var v12648 = UTILS.limit(v12622.p[1], config.positionRange).round(2);
        var v12649 = UTILS.limit(v12622.p[2], config.positionRange).round(2);
        var v12650 = (parseFloat(v12622.s[0]) || 0).round(2);
        var v12651 = (parseFloat(v12622.s[1]) || 0).round(2);
        var v12652 = (parseFloat(v12622.s[2]) || 0).round(2);
        var vUndefined9 = undefined;
        if (!p15672) {
          if (v12622.at != null) {
            var v12653 = v12622.at;
            v12622.at = parseInt((v12622.at + "").replace(/[^\d]/gmi, ""));
            vUndefined9 = (v12653 + "").includes("v") ? v12622.at : undefined;
            v12646 = (v12622.at || 0) + (vUndefined9 ? "/video" : "/texture");
          } else {
            v12646 = v12644.toLowerCase() + "_" + (v12644 == "GRASS" ? 1 : 0);
          }
          if (v12622.tv) {
            v12622.tv = parseInt(v12622.tv) || 0;
          }
          var v12654 = prefabs.getTextureByName(v12644);
          if (v12654 && v12654.variants && v12622.tv && v12654.variants[v12622.tv]) {
            v12646 += "_" + v12654.variants[v12622.tv].id;
          }
        } else if (v12644 == "LINK") {
          ;
        }
        if (!v12622.l && !v12622.col && v12642 == "CUBE") {
          if (v12647 - v12650 < vLN02259) {
            vLN02259 = v12647 - v12650;
          }
          if (v12647 + v12650 > vLN02260) {
            vLN02260 = v12647 + v12650;
          }
          if (v12649 - v12652 < vLN02261) {
            vLN02261 = v12649 - v12652;
          }
          if (v12649 + v12652 > vLN02262) {
            vLN02262 = v12649 + v12652;
          }
          if (v12648 + v12651 > vLN02264) {
            vLN02264 = v12648 + v12651;
          }
          if (v12648 < vLN02263) {
            vLN02263 = v12648;
          }
        }
        if (!p15672 && v12622.tr != null) {
          v12622.tro = UTILS.toDeg(parseFloat(v12622.tr || 0)) || 0;
          delete v12622.tr;
        }
        if (v12642 == "CUBE") {
          this.manager.addBlock(v12647, v12648, v12649, v12650, v12652, v12651, [v12622.f && v12622.f[0] != null ? v12622.f[0] : 1, v12622.f && v12622.f[1] != null ? v12622.f[1] : 1, v12622.f && v12622.f[2] != null ? v12622.f[2] : 1, v12622.f && v12622.f[3] != null ? v12622.f[3] : 1, v12622.f && v12622.f[4] != null ? v12622.f[4] : 1, v12622.f && v12622.f[5] != null ? v12622.f[5] : 1], {
            src: v12646,
            asset: v12622.at != null || undefined,
            video: vUndefined9,
            colr: v12622.c,
            emissive: v12622.e || null,
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            transparent: v12622.o != 1 && v12622.o != null,
            penetrable: parseFloat(v12622.pe) || 0,
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            notWallJ: v12622.wj != null || undefined,
            noGrapple: v12622.gp != null || undefined,
            noShoot: v12622.ns != null || undefined,
            noAICol: v12622.nai != null || undefined,
            noImpulse: v12622.ip != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            amb: v12635.nAmb || v12622.ab != null ? null : config.ambientVal,
            yR: v12622.r ? v12622.r[0] : 0,
            xR: v12622.r ? v12622.r[1] : 0,
            zR: v12622.r ? v12622.r[2] : 0,
            noCol: v12622.l || v12622.col,
            isBorder: v12622.bo == null ? undefined : 1,
            noVis: v12622.v == null ? undefined : 1,
            movT: v12622.ts == null ? undefined : v12622.ts / 10000,
            movD: v12622.td,
            frames: parseInt(v12622.fct) || undefined,
            frameT: parseFloat(v12622.fs) || undefined,
            noAmb: v12622.ab != null || undefined,
            interface: parseInt(v12622.in) || undefined,
            texOffX: parseFloat(v12622.tox) || 0,
            texOffY: parseFloat(v12622.toy) || 0,
            texRot: parseInt(v12622.tro) || 0,
            noFog: v12622.nf != null || undefined,
            scale: v12622.tsr == null ? undefined : 0,
            scaleM: parseFloat(v12622.tsm) || 0,
            fTrans: v12622.ft != null || undefined,
            texEncode: parseInt(v12622.ten) || 0,
            sound: vParseInt47,
            complexColl: v12622.cpx != null || undefined,
            rside: v12622.rs == null ? undefined : parseInt(v12622.rs) || 0,
            darken: parseFloat(v12622.da) || 0,
            noMinimap: v12622.smm != null || undefined
          });
        } else if (v12642 == "SERVER_NODE") {
          this.manager.addServerNode(v12647, v12648, v12649, v12650, v12652, v12651, {
            spread: parseFloat(v12622.ssp) || 0,
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            interface: parseInt(v12622.in) || undefined,
            tag: v12622.nt
          });
        } else if (v12642 == "SPHERE") {
          this.manager.addSphere(v12647, v12648, v12649, v12650, v12652, v12651, {
            src: v12646,
            asset: v12622.at != null || undefined,
            video: vUndefined9,
            colr: v12622.c,
            emissive: v12622.e || null,
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            transparent: v12622.o != 1 && v12622.o != null,
            amb: v12635.nAmb || v12622.ab != null ? null : config.ambientVal,
            yR: v12622.r ? v12622.r[0] : 0,
            xR: v12622.r ? v12622.r[1] : 0,
            zR: v12622.r ? v12622.r[2] : 0,
            noVis: v12622.v == null ? undefined : 1,
            movT: v12622.ts == null ? undefined : v12622.ts / 10000,
            movD: v12622.td,
            frames: parseInt(v12622.fct) || undefined,
            frameT: parseFloat(v12622.fs) || undefined,
            noAmb: v12622.ab != null || undefined,
            texOffX: parseFloat(v12622.tox) || 0,
            texOffY: parseFloat(v12622.toy) || 0,
            texRot: parseInt(v12622.tro) || 0,
            noFog: v12622.nf != null || undefined,
            notWallJ: v12622.wj != null || undefined,
            noGrapple: v12622.gp != null || undefined,
            noShoot: v12622.ns != null || undefined,
            noAICol: v12622.nai != null || undefined,
            noImpulse: v12622.ip != null || undefined,
            fTrans: v12622.ft != null || undefined,
            texEncode: parseInt(v12622.ten) || 0,
            complexColl: v12622.cpx != null || undefined
          });
        } else if (v12642 == "POINT_LIGHT") {
          this.manager.addPointLight(v12647, v12648, v12649, {
            colr: v12622.c,
            intensity: parseFloat(v12622.li) || 1,
            distance: parseFloat(v12622.lds) || 0,
            decay: parseFloat(v12622.ld) || 1
          });
        } else if (v12642 == "DIRECTIONAL_LIGHT") {
          var v12658 = UTILS.limit(v12622.lt[0], config.positionRange).round(2);
          var v12659 = UTILS.limit(v12622.lt[1], config.positionRange).round(2);
          var v12660 = UTILS.limit(v12622.lt[2], config.positionRange).round(2);
          this.manager.addDirectionalLight(v12647, v12648, v12649, v12658, v12659, v12660, {
            colr: v12622.c,
            intensity: parseFloat(v12622.li) || 1
          });
        } else if (v12642 == "SPOT_LIGHT") {
          var v12658 = UTILS.limit(v12622.lt[0], config.positionRange).round(2);
          var v12659 = UTILS.limit(v12622.lt[1], config.positionRange).round(2);
          var v12660 = UTILS.limit(v12622.lt[2], config.positionRange).round(2);
          this.manager.addSpotLight(v12647, v12648, v12649, v12658, v12659, v12660, {
            colr: v12622.c,
            intensity: parseFloat(v12622.li) || 1,
            distance: v12622.lds == null ? 50 : parseFloat(v12622.lds) || 0,
            decay: parseFloat(v12622.ld) || 1,
            angle: parseInt(v12622.la) || 45,
            penumbra: parseFloat(v12622.lp) || 0
          });
        } else if (v12642 == "RECTAREA_LIGHT") {
          this.manager.addRectAreaLight(v12647, v12648, v12649, v12650 / 2, v12651 / 2, {
            colr: v12622.c,
            intensity: parseFloat(v12622.li) || 1
          }, v12622.r ? v12622.r[2] : 0, v12622.r ? v12622.r[0] : 0, v12622.r ? v12622.r[1] : 0);
        } else if (v12642 == "MYSTERY_BOX") {
          this.manager.addMysteryBox(v12647, v12648, v12649, v12622.r, v12650 / 2, v12651 / 2, v12652 / 2, {
            scoreP: parseInt(v12622.sp) || 0
          });
        } else if (v12642 == "PERK_MACHINE") {
          this.manager.addPerkMachine(v12647, v12648, v12649, v12622.r, v12650 / 2, v12651 / 2, v12652 / 2, {
            scoreP: parseInt(v12622.sp) || 0,
            perk: parseInt(v12622.zp) || 0,
            isBorder: v12622.bo == null ? undefined : 1,
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            interface: parseInt(v12622.in) || undefined
          });
        } else if (v12642 == "KRUM_MACHINE") {
          this.manager.addKrumMachine(v12647, v12648, v12649, v12622.r, v12650 / 2, v12651 / 2, v12652 / 2, {
            scoreP: parseInt(v12622.sp) || 0,
            isBorder: v12622.bo == null ? undefined : 1
          });
        } else if (v12642 == "GATE") {
          this.manager.addGate(v12647, v12648, v12649, v12650, v12652, v12651, [v12622.f && v12622.f[0] != null ? v12622.f[0] : 1, v12622.f && v12622.f[1] != null ? v12622.f[1] : 1, v12622.f && v12622.f[2] != null ? v12622.f[2] : 1, v12622.f && v12622.f[3] != null ? v12622.f[3] : 1, v12622.f && v12622.f[4] != null ? v12622.f[4] : 1, v12622.f && v12622.f[5] != null ? v12622.f[5] : 1], {
            src: v12646,
            asset: v12622.at != null || undefined,
            video: vUndefined9,
            colr: v12622.c,
            emissive: v12622.e || null,
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            transparent: v12622.o != 1 && v12622.o != null,
            penetrable: parseFloat(v12622.pe) || 0,
            amb: v12635.nAmb || v12622.ab != null ? null : config.ambientVal,
            yR: v12622.r ? v12622.r[0] : 0,
            xR: v12622.r ? v12622.r[1] : 0,
            zR: v12622.r ? v12622.r[2] : 0,
            isBorder: v12622.bo == null ? undefined : 1,
            noVis: v12622.v == null ? undefined : 1,
            movT: v12622.ts == null ? undefined : v12622.ts / 10000,
            movD: v12622.td,
            frames: parseInt(v12622.fct) || undefined,
            frameT: parseFloat(v12622.fs) || undefined,
            noAmb: v12622.ab != null || undefined,
            scoreP: parseInt(v12622.sp) || 0,
            noMsg: v12622.nm != null || undefined,
            method: parseInt(v12622.md) || 0,
            closeable: v12622.cl != null || undefined,
            startClosed: v12622.stc != null || undefined,
            interface: parseInt(v12622.in) || undefined,
            texOffX: parseFloat(v12622.tox) || 0,
            texOffY: parseFloat(v12622.toy) || 0,
            texRot: parseInt(v12622.tro) || 0,
            team: parseInt(v12622.tm || 0) || 0,
            notWallJ: v12622.wj != null || undefined,
            noGrapple: v12622.gp != null || undefined,
            noShoot: v12622.ns != null || undefined,
            noAICol: v12622.nai != null || undefined,
            noImpulse: v12622.ip != null || undefined,
            fTrans: v12622.ft != null || undefined,
            scale: v12622.tsr == null ? undefined : 0,
            scaleM: parseFloat(v12622.tsm) || 0,
            interactMsg: v12622.inm,
            texEncode: parseInt(v12622.ten) || 0,
            sound: vParseInt47,
            noFog: v12622.nf != null || undefined,
            noMinimap: v12622.smm != null || undefined
          });
        } else if (v12642 == "TRIGGER") {
          if (!v12622.tas || !Array.isArray(v12622.tas) || !v12622.tas.length) {
            v12622.tas = [{
              tc: v12622.tc,
              tc2: v12622.tc2,
              tct: v12622.tct,
              tcc: v12622.tcc,
              tce: v12622.tce,
              ta: v12622.ta,
              esa: v12622.esa,
              es: v12622.es,
              ev: v12622.ev,
              er: v12622.er,
              ef: v12622.ef,
              tad: v12622.tad,
              cd: v12622.cd,
              cv0: v12622.cv0,
              cv1: v12622.cv1,
              cv2: v12622.cv2
            }];
          }
          this.manager.addTrigger(v12647, v12648, v12649, v12622.r, v12650, v12652, v12651, [v12622.f && v12622.f[0] != null ? v12622.f[0] : 1, v12622.f && v12622.f[1] != null ? v12622.f[1] : 1, v12622.f && v12622.f[2] != null ? v12622.f[2] : 1, v12622.f && v12622.f[3] != null ? v12622.f[3] : 1, v12622.f && v12622.f[4] != null ? v12622.f[4] : 1, v12622.f && v12622.f[5] != null ? v12622.f[5] : 1], {
            src: v12646,
            assetTexture: v12622.at != null || undefined,
            video: vUndefined9,
            colr: v12622.c,
            emissive: v12622.e || null,
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            transparent: v12622.o != 1 && v12622.o != null,
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            selfDestruct: v12622.sfd != null || undefined,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            amb: v12635.nAmb || v12622.ab != null ? null : config.ambientVal,
            yR: v12622.r ? v12622.r[0] : 0,
            xR: v12622.r ? v12622.r[1] : 0,
            zR: v12622.r ? v12622.r[2] : 0,
            noVis: v12622.v == null ? undefined : 1,
            noPCol: v12622.pl != null,
            movT: v12622.ts == null ? undefined : v12622.ts / 10000,
            movD: v12622.td,
            frames: parseInt(v12622.fct) || undefined,
            frameT: parseFloat(v12622.fs) || undefined,
            noAmb: v12622.ab != null || undefined,
            constE: parseInt(v12622.tce) || 0,
            event: parseInt(v12622.te) || 0,
            eventN: triggers.events[parseInt(v12622.te) || 0] ? triggers.events[parseInt(v12622.te) || 0].name : null,
            chance: parseInt(v12622.cha) || 0,
            actionCost: parseInt(v12622.tac) || 0,
            actionMethod: parseInt(v12622.tam) || 0,
            interface: parseInt(v12622.in) || undefined,
            interfaceT: parseInt(v12622.tin) || undefined,
            texOffX: parseFloat(v12622.tox) || 0,
            texOffY: parseFloat(v12622.toy) || 0,
            texRot: parseInt(v12622.tro) || 0,
            team: parseInt(v12622.tm || 0) || 0,
            singleUse: v12622.su != null || undefined,
            singleUseP: v12622.sup != null || undefined,
            notWallJ: v12622.wj != null || undefined,
            noGrapple: v12622.gp != null || undefined,
            noShoot: v12622.ns != null || undefined,
            noAICol: v12622.nai != null || undefined,
            noImpulse: v12622.ip != null || undefined,
            fTrans: v12622.ft != null || undefined,
            scale: v12622.tsr == null ? undefined : 0,
            scaleM: parseFloat(v12622.tsm) || 0,
            actions: v12622.tas && Array.isArray(v12622.tas) ? v12622.tas : null,
            interactMsg: v12622.inm,
            texEncode: parseInt(v12622.ten) || 0,
            asset: v12622.aid,
            mSize: parseFloat(v12622.ms),
            noSmooth: v12622.txs != null || undefined,
            spin: parseFloat(v12622.spn || 0) || 0,
            spinAxis: parseInt(v12622.spa || 0) || 0,
            cast: v12622.cst == null || undefined,
            receive: v12622.rcv == null || undefined,
            animS: parseFloat(v12622.as) || 0,
            startAnim: v12622.ast,
            forceRender: v12622.fcr != null || undefined,
            alphaTest: parseFloat(v12622.alt || 0) || 0,
            sound: vParseInt47,
            noFog: v12622.nf != null || undefined,
            side: parseInt(v12622.rs) || 0,
            fTrans: v12622.ft != null || undefined,
            hbh: parseFloat(v12622.hbh) || 1,
            hbw: parseFloat(v12622.hbw) || 1,
            noMinimap: v12622.smm != null || undefined
          }, triggers);
        } else if (v12642 == "PRIZE_WHEEL") {
          this.manager.addSpinner(v12647, v12648, v12649, v12650, v12651, v12652, v12622.d || 0, {
            transparent: v12622.o != 1 && v12622.o != null,
            amb: v12635.nAmb || v12622.ab != null ? null : config.ambientVal,
            noAmb: v12622.ab != null || undefined,
            scale: 0,
            tRadius: 7,
            wheel: parseInt(v12622.sty) || 0
          });
        } else if (v12642 == "SPRAY") {
          this.manager.addSpray(v12647, v12648, v12649, v12650 / 2, v12652 / 2, {
            scale: v12642 == "PLANE" && v12622.tsr == null ? 1 : 0,
            noAmb: true,
            colr: v12622.c,
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            side: 0,
            sprayIndex: parseInt(v12622.spt) || 2482
          }, v12622.r ? v12622.r[0] : 0, v12622.r ? v12622.r[1] : 0, v12622.r ? v12622.r[2] : 0, store);
        } else if (v12642 == "TERMINAL") {
          ;
        } else if (v12642 == "DEPOSIT_BOX") {
          this.manager.addBank(v12647, v12648, v12649, v12650, v12652, v12651, [v12622.f && v12622.f[0] != null ? v12622.f[0] : 1, v12622.f && v12622.f[1] != null ? v12622.f[1] : 1, v12622.f && v12622.f[2] != null ? v12622.f[2] : 1, v12622.f && v12622.f[3] != null ? v12622.f[3] : 1, v12622.f && v12622.f[4] != null ? v12622.f[4] : 1, v12622.f && v12622.f[5] != null ? v12622.f[5] : 1], {
            src: v12646,
            asset: v12622.at != null || undefined,
            video: vUndefined9,
            colr: v12622.c,
            emissive: v12622.e || null,
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            transparent: v12622.o != 1 && v12622.o != null,
            penetrable: parseFloat(v12622.pe) || 0,
            amb: v12635.nAmb || v12622.ab != null ? null : config.ambientVal,
            yR: v12622.r ? v12622.r[0] : 0,
            xR: v12622.r ? v12622.r[1] : 0,
            zR: v12622.r ? v12622.r[2] : 0,
            isBorder: v12622.bo == null ? undefined : 1,
            noVis: v12622.v == null ? undefined : 1,
            movT: v12622.ts == null ? undefined : v12622.ts / 10000,
            movD: v12622.td,
            frames: parseInt(v12622.fct) || undefined,
            frameT: parseFloat(v12622.fs) || undefined,
            noAmb: v12622.ab != null || undefined,
            interface: parseInt(v12622.in) || undefined,
            withdraw: v12622.wd == null ? 1000 : parseInt(v12622.wd) || 0,
            deposit: v12622.dp == null ? 1000 : parseInt(v12622.dp) || 0,
            texOffX: parseFloat(v12622.tox) || 0,
            texOffY: parseFloat(v12622.toy) || 0,
            texRot: parseInt(v12622.tro) || 0,
            team: parseInt(v12622.tm || 0) || 0,
            notWallJ: v12622.wj != null || undefined,
            noGrapple: v12622.gp != null || undefined,
            noShoot: v12622.ns != null || undefined,
            noAICol: v12622.nai != null || undefined,
            noImpulse: v12622.ip != null || undefined,
            fTrans: v12622.ft != null || undefined,
            scale: v12622.tsr == null ? undefined : 0,
            scaleM: parseFloat(v12622.tsm) || 0,
            texEncode: parseInt(v12622.ten) || 0,
            sound: vParseInt47,
            noFog: v12622.nf != null || undefined,
            noMinimap: v12622.smm != null || undefined
          });
        } else if (v12642 == "LIGHT_CONE") {
          if (p15650 && p15650.mapDet) {
            this.manager.addLightCone(v12647, v12648, v12649, v12650, v12652, v12651, {
              src: "lightcone_" + (v12622.fc == null ? 0 : 1),
              colr: v12622.c,
              opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
              yR: v12622.r ? v12622.r[0] : 0,
              xR: v12622.r ? v12622.r[1] : 0,
              zR: v12622.r ? v12622.r[2] : 0,
              noVis: v12622.v == null ? undefined : 1,
              movT: v12622.ts == null ? undefined : v12622.ts / 10000,
              movD: v12622.td,
              texEncode: parseInt(v12622.ten) || 0,
              thetaL: v12622.thl == null ? 360 : parseFloat(v12622.thl) || 0.1,
              sides: parseInt(v12622.sds) || 12
            });
          }
        } else if (v12642 == "LIGHT_BAR") {
          if (p15650 && p15650.mapDet) {
            this.manager.addLightBar(v12647, v12648, v12649, v12650 / 2, v12652 / 2, {
              src: "lightcone_1",
              colr: v12622.c,
              emissive: v12622.e || null,
              opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
              noVis: v12622.v == null ? undefined : 1,
              movT: v12622.ts == null ? undefined : v12622.ts / 10000,
              movD: v12622.td,
              texEncode: parseInt(v12622.ten) || 0,
              mimicSprite: v12622.msp != null || undefined
            }, v12622.r ? v12622.r[0] : 0, v12622.r ? v12622.r[1] : 0, v12622.r ? v12622.r[2] : 0);
          }
        } else if (v12642 == "CYLINDER") {
          this.manager.addCylinder(v12647, v12648, v12649, v12650, v12652, v12651, {
            src: v12646,
            asset: v12622.at != null || undefined,
            video: vUndefined9,
            colr: v12622.c,
            emissive: v12622.e || null,
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            transparent: v12622.o != 1 && v12622.o != null,
            yR: v12622.r ? v12622.r[0] : 0,
            xR: v12622.r ? v12622.r[1] : 0,
            zR: v12622.r ? v12622.r[2] : 0,
            noVis: v12622.v == null ? undefined : 1,
            movT: v12622.ts == null ? undefined : v12622.ts / 10000,
            movD: v12622.td,
            frames: parseInt(v12622.fct) || undefined,
            frameT: parseFloat(v12622.fs) || undefined,
            spin: parseFloat(v12622.spn || 0) || 0,
            noCol: v12622.l || v12622.col,
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            interface: parseInt(v12622.in) || undefined,
            texOffX: parseFloat(v12622.tox) || 0,
            texOffY: parseFloat(v12622.toy) || 0,
            texRot: parseInt(v12622.tro) || 0,
            sides: parseInt(v12622.sds) || 12,
            open: v12622.opn != null || undefined,
            rTop: v12622.rtp == null ? 1 : parseFloat(v12622.rtp) || 0,
            rBot: v12622.rbt == null ? 1 : parseFloat(v12622.rbt) || 0,
            thetaS: v12622.ths == null ? 0 : parseFloat(v12622.ths) || 0,
            thetaL: v12622.thl == null ? 360 : parseFloat(v12622.thl) || 0.1,
            notWallJ: v12622.wj != null || undefined,
            noGrapple: v12622.gp != null || undefined,
            noShoot: v12622.ns != null || undefined,
            noAICol: v12622.nai != null || undefined,
            noImpulse: v12622.ip != null || undefined,
            fTrans: v12622.ft != null || undefined,
            scale: v12622.tsr == null ? undefined : 0,
            scaleM: parseFloat(v12622.tsm) || 0,
            penetrable: parseFloat(v12622.pe) || 0,
            texEncode: parseInt(v12622.ten) || 0,
            complexColl: v12622.cpx != null || undefined,
            noMinimap: true
          });
        } else if (v12642 == "SOUND_EMITTER") {
          this.manager.addEmitter(v12647, v12648, v12649, {
            snd: parseInt(v12622.esa || v12622.es) || 0,
            assetSnd: v12622.esa != null || undefined,
            vol: parseFloat(v12622.ev) || 1,
            rate: parseFloat(v12622.er) || 1,
            dist: parseInt(v12622.ed) || 0,
            distM: parseInt(v12622.edm) || 0,
            roll: parseFloat(v12622.ero) || 0
          });
        } else if (v12642 == "OBJECTIVE") {
          this.manager.addObjective(v12647, v12648, v12649, v12650, v12652, v12651, {
            objId: parseInt(v12622.obi) || 0
          });
        } else if (v12642 == "DOMINATION_ZONE") {
          this.manager.addDominationZone(v12647, v12648, v12649, v12650, v12652, v12651);
        } else if (v12642 == "BOMB_SITE") {
          this.manager.addBombSite(v12647, v12648, v12649, v12650, v12652, v12651);
        } else if (v12642 == "FLAG") {
          this.manager.addFlag(v12647, v12648, v12649, parseInt(v12622.tm || 0));
        } else if (v12642 == "BOOST_PAD") {
          this.manager.addPad(v12647, v12648, v12649, v12650, v12652, v12651, {
            bounce: v12622.bm == null ? 1 : parseFloat(v12622.bm || 0) || 0,
            crouch: v12622.cr == null || undefined,
            noVis: v12622.v == null ? undefined : 1,
            xR: v12622.r ? v12622.r[0] : 0,
            yR: v12622.r ? v12622.r[1] : 0,
            zR: v12622.r ? v12622.r[2] : 0,
            direction: v12622.d || 0
          }, v12622.r);
        } else if (v12642 == "WEAPON_PICKUP") {
          this.manager.addWeapon(v12647, v12648, v12649, {
            scoreP: parseInt(v12622.sp) || 0,
            noMsg: v12622.nm != null || undefined,
            method: parseInt(v12622.md) || 0,
            noRep: v12622.wr,
            weaponId: parseInt(v12622.w || v12622.wid || 0),
            random: v12622.rw != null || undefined,
            randomGroup: v12622.rwg == null ? undefined : parseInt(v12622.rwg || 0) || 0,
            showIcon: v12622.wpi === undefined || undefined,
            team: parseInt(v12622.tm || 0) || 0,
            interactMsg: v12622.inm,
            noTex: v12622.ntx != null || undefined
          }, v12622.r ? v12622.r[2] : 0, v12622.r ? v12622.r[0] : 0, v12622.r ? v12622.r[1] : 0, weapons);
        } else if (v12642 == "SHOWCASE") {
          this.manager.addShowcase(v12647, v12648, v12649, v12622.r, v12650 / 2, v12651 / 2, v12652 / 2, {
            itemID: parseInt(v12622.skin || 0),
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            transparent: v12622.o != 1 && v12622.o != null,
            colr: v12622.c,
            noAmb: v12622.ab != null || undefined,
            mSize: parseFloat(v12622.ms),
            spin: parseFloat(v12622.spn || 0) || 0,
            spinAxis: parseInt(v12622.spa || 0) || 0
          }, weapons, store);
        } else if (v12642 == "PARTICLES") {
          if (PARTICLES) {
            PARTICLES.area(v12647, v12648, v12649, v12650, v12651, v12652, {
              txt: parseInt(v12622.pr) || 0,
              spd: parseInt(v12622.psp) || 0,
              decl: parseInt(v12622.pd) || 1,
              cnt: parseInt(v12622.pc) || 0,
              grav: parseInt(v12622.pg) || 0,
              scl: parseInt(v12622.psc) || 1,
              siz: parseInt(v12622.ps) || 1,
              dir: v12622.d || 0,
              colr: v12622.c,
              blend: v12622.pb || 0
            });
          }
        } else if (v12642 == "SPRITE") {
          this.manager.addSprite(v12647, v12648, v12649, v12650 / 2, v12652 / 2, {
            src: v12646,
            asset: v12622.at != null || undefined,
            video: vUndefined9,
            scale: v12622.tsr == null ? 1 : 0,
            scaleM: parseFloat(v12622.tsm) || 0,
            emissive: v12622.e || null,
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            transparent: v12622.o != 1 && v12622.o != null,
            colr: v12622.c,
            noVis: v12622.v == null ? undefined : 1,
            side: 0,
            movT: v12622.ts == null ? undefined : v12622.ts / 10000,
            movD: v12622.td,
            frames: parseInt(v12622.fct) || undefined,
            frameT: parseFloat(v12622.fs) || undefined,
            noAmb: v12622.ab != null || undefined,
            texOffX: parseFloat(v12622.tox) || 0,
            texOffY: parseFloat(v12622.toy) || 0,
            texRot: parseInt(v12622.tro) || 0,
            fTrans: v12622.ft != null || undefined,
            texEncode: parseInt(v12622.ten) || 0
          });
        } else if (v12642 == "PLANE") {
          this.manager.addFixedPlane(v12647, v12648, v12649, v12650 / 2, v12652 / 2, {
            src: v12646,
            asset: v12622.at != null || undefined,
            video: vUndefined9,
            scale: v12642 == "PLANE" && v12622.tsr == null ? 1 : 0,
            scaleM: parseFloat(v12622.tsm) || 0,
            emissive: v12622.e || null,
            noise: v12622.en || 0,
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            penetrable: parseFloat(v12622.pe) || 0,
            transparent: v12622.o != 1 && v12622.o != null,
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            colr: v12622.c,
            noCol: v12622.l || v12622.col,
            noVis: v12622.v == null ? undefined : 1,
            side: 0,
            movT: v12622.ts == null ? undefined : v12622.ts / 10000,
            movD: v12622.td,
            frames: parseInt(v12622.fct) || undefined,
            frameT: parseFloat(v12622.fs) || undefined,
            noAmb: v12622.ab != null || undefined,
            interface: parseInt(v12622.in) || undefined,
            texOffX: parseFloat(v12622.tox) || 0,
            texOffY: parseFloat(v12622.toy) || 0,
            texRot: parseInt(v12622.tro) || 0,
            notWallJ: v12622.wj != null || undefined,
            noGrapple: v12622.gp != null || undefined,
            noShoot: v12622.ns != null || undefined,
            noAICol: v12622.nai != null || undefined,
            noImpulse: v12622.ip != null || undefined,
            fTrans: v12622.ft != null || undefined,
            texEncode: parseInt(v12622.ten) || 0,
            mimicSprite: v12622.msp != null || undefined,
            sound: vParseInt47,
            noFog: v12622.nf != null || undefined,
            alphaTest: parseFloat(v12622.alt || 0) || 0,
            complexColl: v12622.cpx != null || undefined,
            darken: parseFloat(v12622.da) || 0,
            noMinimap: v12622.smm != null || undefined
          }, v12622.r ? v12622.r[0] : 0, v12622.r ? v12622.r[1] : 0, v12622.r ? v12622.r[2] : 0);
        } else if (v12642 == "BILLBOARD") {
          v12622.bb = UTILS.isNumber(v12622.bb) ? UTILS.limitMM(parseInt(v12622.bb), 1, config.billboards.length - 1) : UTILS.randInt(1, config.billboards.length - 1);
          this.manager.addFixedPlane(v12647, v12648, v12649, v12650 / 2, v12652 / 2, {
            src: "pubs/b_" + v12622.bb,
            asset: v12622.at != null || undefined,
            video: vUndefined9,
            scale: v12642 == "PLANE" && v12622.tsr == null ? 1 : 0,
            scaleM: parseFloat(v12622.tsm) || 0,
            emissive: v12622.e || null,
            noise: v12622.en || 0,
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            penetrable: parseFloat(v12622.pe) || 0,
            transparent: v12622.o != 1 && v12622.o != null,
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            colr: v12622.c,
            noCol: v12622.l || v12622.col,
            noVis: v12622.v == null ? undefined : 1,
            side: 2,
            movT: v12622.ts == null ? undefined : v12622.ts / 10000,
            movD: v12622.td,
            frames: parseInt(v12622.fct) || undefined,
            frameT: parseFloat(v12622.fs) || undefined,
            noAmb: v12622.ab != null || undefined,
            interface: parseInt(v12622.in) || undefined,
            texOffX: parseFloat(v12622.tox) || 0,
            texOffY: parseFloat(v12622.toy) || 0,
            texRot: parseInt(v12622.tro) || 0,
            notWallJ: v12622.wj != null || undefined,
            fTrans: v12622.ft != null || undefined,
            texEncode: parseInt(v12622.ten) || 0,
            mimicSprite: v12622.msp != null || undefined,
            noFog: v12622.nf != null || undefined,
            alphaTest: parseFloat(v12622.alt || 0) || 0,
            noMinimap: true
          }, v12622.r ? v12622.r[0] : 0, v12622.r ? v12622.r[1] : 0, v12622.r ? v12622.r[2] : 0);
        } else if (v12642 == "LIQUID") {
          this.manager.addLiquid(v12647, v12648, v12649, v12650 / 2, v12652 / 2, {
            src: v12646,
            asset: v12622.at != null || undefined,
            video: vUndefined9,
            emissive: v12622.e || null,
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            colr: v12622.c,
            noVis: v12622.v == null ? undefined : 1,
            movT: v12622.ts == null ? undefined : v12622.ts / 10000,
            movD: v12622.td,
            noAmb: v12622.ab != null || undefined,
            wHeight: parseFloat(v12622.wh) || 0.5,
            wSpeed: parseFloat(v12622.ws) || 10,
            tilesX: parseInt(v12622.tx) || 10,
            tilesZ: parseInt(v12622.tz) || 10,
            texOffX: parseFloat(v12622.tox) || 0,
            texOffY: parseFloat(v12622.toy) || 0,
            texRot: parseInt(v12622.tro) || 0,
            texEncode: parseInt(v12622.ten) || 0
          }, v12622.r ? v12622.r[0] : 0, v12622.r ? v12622.r[1] : 0, v12622.r ? v12622.r[2] : 0);
        } else if (v12642 == "SIGN") {
          this.manager.addCanvas(v12647, v12648, v12649, v12650 / 2, v12652 / 2, {
            noCol: v12622.l || v12622.col,
            fontSize: parseInt(v12622.sf) || 10,
            text: v12622.st,
            tAlign: parseInt(v12622.sa) || 0,
            fcolr: v12622.sc,
            bcolr: v12622.sb,
            ocolr: v12622.so,
            othick: parseInt(v12622.sot) || 1,
            noBVis: v12622.bv,
            noSCF: v12622.nsf != null,
            movT: v12622.ts == null ? undefined : v12622.ts / 10000,
            movD: v12622.td,
            mimicSprite: v12622.msp != null || undefined
          }, v12622.r ? v12622.r[0] : 0, v12622.r ? v12622.r[1] : 0, v12622.r ? v12622.r[2] : 0);
        } else if (v12642 == "LEADERBOARD") {
          this.manager.addLeaderBoard(v12647, v12648, v12649, v12650 / 2, v12652 / 2, {
            noCol: v12622.l || v12622.col,
            fontSize: parseInt(v12622.sf) || 10,
            fcolr: v12622.sc,
            bcolr: v12622.sb,
            noBVis: v12622.bv,
            noSCF: v12622.nsf != null,
            movT: v12622.ts == null ? undefined : v12622.ts / 10000,
            movD: v12622.td,
            leaderType: parseInt(v12622.ldt) || 0,
            leaderTypeCust: v12622.ldc,
            leaderOrder: parseInt(v12622.ldo) || 0,
            leaderResults: parseInt(v12622.ldr) || 25,
            mimicSprite: v12622.msp != null || undefined
          }, v12622.r ? v12622.r[0] : 0, v12622.r ? v12622.r[1] : 0, v12622.r ? v12622.r[2] : 0);
        } else if (v12642 == "CAMERA") {
          this.manager.addCamera(v12647, v12648, v12649, {
            camType: parseInt(v12622.camt) || 0,
            forceCam: v12622.frc != null || undefined,
            followPath: v12622.fp || "",
            objLink: v12622.obl || 0,
            yR: v12622.r ? v12622.r[0] : 0,
            xR: v12622.r ? v12622.r[1] : 0,
            zR: v12622.r ? v12622.r[2] : 0
          });
        } else if (v12642 == "RAMP") {
          this.manager.addRamp(v12647, v12648, v12649, v12650, v12651, v12652, (v12622.d || 0) * Math.PI / 2, {
            src: v12646,
            asset: v12622.at != null || undefined,
            video: vUndefined9,
            boost: v12622.b,
            scale: v12622.tsr == null ? 1 : 0,
            scaleM: parseFloat(v12622.tsm) || 0,
            emissive: v12622.e || null,
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            transparent: v12622.o != 1 && v12622.o != null,
            colr: v12622.c,
            noCol: v12622.l || v12622.col,
            noAICol: v12622.nai != null || undefined,
            noVis: v12622.v == null ? undefined : 1,
            movT: v12622.ts == null ? undefined : v12622.ts / 10000,
            movD: v12622.td,
            frames: parseInt(v12622.fct) || undefined,
            frameT: parseFloat(v12622.fs) || undefined,
            noAmb: v12622.ab != null || undefined,
            texOffX: parseFloat(v12622.tox) || 0,
            texOffY: parseFloat(v12622.toy) || 0,
            texRot: parseInt(v12622.tro) || 0,
            fTrans: v12622.ft != null || undefined,
            enclose: v12622.ec != null || undefined,
            texEncode: parseInt(v12622.ten) || 0,
            sound: vParseInt47,
            noMinimap: v12622.smm != null || undefined
          });
        } else if (v12642 == "AI_REDIRECTION") {
          this.manager.addAIRedirection(v12647, v12648, v12649, v12650, v12651, v12652, (v12622.d || 0) * Math.PI / 2, {
            boost: v12622.b
          });
        } else if (v12642 == "PREMIUM_ZONE") {
          this.manager.addPremiumZone(v12647, v12648, v12649, v12650, v12652, v12651, {
            isBorder: v12622.bo == null ? undefined : 1,
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            interface: parseInt(v12622.in) || undefined
          });
        } else if (v12642 == "VERIFIED_ZONE") {
          this.manager.addVerifiedZone(v12647, v12648, v12649, v12650, v12652, v12651, {
            isBorder: v12622.bo == null ? undefined : 1,
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            interface: parseInt(v12622.in) || undefined
          });
        } else if (v12642 == "PARTNER_ZONE") {
          this.manager.addPartnerZone(v12647, v12648, v12649, v12650, v12652, v12651, {
            isBorder: v12622.bo == null ? undefined : 1,
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            interface: parseInt(v12622.in) || undefined
          });
        } else if (v12642 == "TEAM_ZONE") {
          this.manager.addTeamZone(v12647, v12648, v12649, v12650, v12652, v12651, {
            team: parseInt(v12622.tm || 0) || 0,
            isBorder: v12622.bo == null ? undefined : 1,
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            interface: parseInt(v12622.in) || undefined
          });
        } else if (v12642 == "KR_ZONE") {
          this.manager.addKRZone(v12647, v12648, v12649, v12650, v12652, v12651, {
            amount: parseInt(v12622.krs || 0) || 0,
            isBorder: v12622.bo == null ? undefined : 1,
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            interface: parseInt(v12622.in) || undefined
          });
        } else if (v12642 == "NOPVP_ZONE") {
          this.manager.addNOPVPZone(v12647, v12648, v12649, v12650, v12652, v12651, {
            isBorder: v12622.bo == null ? undefined : 1,
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            interface: parseInt(v12622.in) || undefined
          });
        } else if (v12642 == "PVP_ZONE") {
          this.manager.addPVPZone(v12647, v12648, v12649, v12650, v12652, v12651, {
            isBorder: v12622.bo == null ? undefined : 1,
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            interface: parseInt(v12622.in) || undefined
          });
        } else if (v12642 == "KPD_ZONE") {
          this.manager.addKPDZone(v12647, v12648, v12649, v12650, v12652, v12651, {
            isBorder: v12622.bo == null ? undefined : 1,
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            interface: parseInt(v12622.in) || undefined
          });
        } else if (v12642 == "SCORE_ZONE") {
          this.manager.addScoreZone(v12647, v12648, v12649, v12650, v12652, v12651, parseInt(v12622.sp) || 1);
        } else if (v12642 == "DEATH_ZONE") {
          this.manager.addDeathZone(v12647, v12648, v12649, v12650, v12652, v12651, {
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            interface: parseInt(v12622.in) || undefined
          });
        } else if (v12642 == "CHECK_POINT") {
          this.manager.addCheckPoint(v12647, v12648, v12649, v12650, v12652, v12651, {
            singleUse: v12622.su != null || undefined,
            direction: v12622.d || 0,
            team: parseInt(v12622.tm || 0) || 0
          });
        } else if (v12642 == "TELEPORTER") {
          this.manager.addTeleporter(v12647, v12648, v12649, v12650, v12652, v12651, {
            direction: v12622.d || 0,
            forceDir: v12622.fd != null,
            channel: parseInt(v12622.ch || 0),
            node: parseInt(v12622.n || 0),
            momentum: v12622.m != null,
            team: parseInt(v12622.tm || 0) || 0,
            telCheckPoint: v12622.tcp != null || undefined
          });
        } else if (v12642 == "LADDER") {
          this.manager.addLadder(v12647, v12648, v12649, v12651, (v12622.d || 0) * Math.PI / 2, {
            src: v12646,
            asset: v12622.at != null || undefined,
            video: vUndefined9,
            scale: v12622.tsr == null ? 0.02 : 1,
            scaleM: parseFloat(v12622.tsm) || 0,
            emissive: v12622.e || null,
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            transparent: v12622.o != 1 && v12622.o != null,
            colr: v12622.c,
            noVis: v12622.v == null ? undefined : 1,
            texOffX: parseFloat(v12622.tox) || 0,
            texOffY: parseFloat(v12622.toy) || 0,
            texRot: parseInt(v12622.tro) || 0,
            notWallJ: v12622.wj != null || undefined,
            noGrapple: v12622.gp != null || undefined,
            noImpulse: v12622.ip != null || undefined,
            fTrans: v12622.ft != null || undefined,
            texEncode: parseInt(v12622.ten) || 0,
            sound: vParseInt47
          });
        } else if (v12642 == "ROPE_LADDER") {
          this.manager.addRopeLadder(v12647, v12648, v12649, v12650, v12652, v12651, {
            src: v12646,
            asset: v12622.at != null || undefined,
            video: vUndefined9,
            colr: v12622.c,
            emissive: v12622.e || null,
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            transparent: v12622.o != 1 && v12622.o != null,
            amb: v12635.nAmb || v12622.ab != null ? null : config.ambientVal,
            yR: v12622.r ? v12622.r[0] : 0,
            xR: v12622.r ? v12622.r[1] : 0,
            zR: v12622.r ? v12622.r[2] : 0,
            noVis: v12622.v == null ? undefined : 1,
            movT: v12622.ts == null ? undefined : v12622.ts / 10000,
            movD: v12622.td,
            frames: parseInt(v12622.fct) || undefined,
            frameT: parseFloat(v12622.fs) || undefined,
            noAmb: v12622.ab != null || undefined,
            texOffX: parseFloat(v12622.tox) || 0,
            texOffY: parseFloat(v12622.toy) || 0,
            texRot: parseInt(v12622.tro) || 0,
            noFog: v12622.nf != null || undefined,
            scale: v12622.tsr == null ? undefined : 0,
            scaleM: parseFloat(v12622.tsm) || 0,
            sides: parseInt(v12622.sds) || 12,
            open: v12622.opn != null || undefined,
            rTop: v12622.rtp == null ? 1 : parseFloat(v12622.rtp) || 0,
            rBot: v12622.rbt == null ? 1 : parseFloat(v12622.rbt) || 0,
            fTrans: v12622.ft != null || undefined,
            texEncode: parseInt(v12622.ten) || 0,
            sound: vParseInt47
          });
        } else if (v12642 == "AI_SPAWNER") {
          if (!v12622.tas || !Array.isArray(v12622.tas) || !v12622.tas.length) {
            v12622.tas = [{
              tc: v12622.tc,
              tc2: v12622.tc2,
              tct: v12622.tct,
              tcc: v12622.tcc,
              tce: v12622.tce,
              ta: v12622.ta,
              esa: v12622.esa,
              es: v12622.es,
              ev: v12622.ev,
              er: v12622.er,
              ef: v12622.ef,
              tad: v12622.tad,
              cd: v12622.cd,
              cv0: v12622.cv0,
              cv1: v12622.cv1,
              cv2: v12622.cv2
            }];
          }
          this.manager.addAI(v12647, v12648, v12649, v12622.r, v12650 / 2, v12651 / 2, v12652 / 2, v12622, triggers);
        } else if (v12642 == "BOT_SPAWNER") {
          this.manager.addBot(v12647, v12648, v12649, (v12622.d || 0) * Math.PI / 2, v12622);
        } else if (v12642 == "MAP_ANCHOR") {
          this.manager.addMapAnchor(v12647, v12648, v12649, parseInt(v12622.ant) || 0);
        } else if (v12642 == "ENVIRONMENT_ZONE") {
          this.manager.addEnvironmentZone(v12647, v12648, v12649, v12650, v12652, v12651, v12622);
        } else if (v12642 == "PATH_NODE") {
          this.manager.addPathNode(v12647, v12648, v12649, {
            id: parseInt(v12622.nid) || 0
          });
        } else if (v12642 == "RUNE") {
          this.manager.addFixedPlane(v12647, v12648 + 0.01, v12649, v12650 / 2, v12652 / 2, {
            src: "rune_0",
            scale: 0,
            emissive: v12622.e || null,
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            transparent: true,
            penetrable: parseFloat(v12622.pe) || 0,
            colr: v12622.c,
            noCol: v12622.l || v12622.col,
            noVis: v12622.v == null ? undefined : 1,
            side: 2,
            shadows: false,
            alphaTest: prefabs.prefabs[57].alphaTest,
            movT: v12622.ts == null ? undefined : v12622.ts / 10000,
            movD: v12622.td,
            noAmb: v12622.ab != null || undefined,
            notWallJ: v12622.wj != null || undefined,
            noGrapple: v12622.gp != null || undefined,
            noShoot: v12622.ns != null || undefined,
            noAICol: v12622.nai != null || undefined,
            noImpulse: v12622.ip != null || undefined,
            texEncode: parseInt(v12622.ten) || 0,
            fTrans: true,
            mimicSprite: v12622.msp != null || undefined,
            noMinimap: v12622.smm != null || undefined
          }, v12622.r ? v12622.r[0] : 0, v12622.r ? v12622.r[1] : 0, v12622.r ? v12622.r[2] : 0);
        } else if (v12642 == "CUSTOM_ASSET") {
          this.manager.addAsset(v12647, v12648, v12649, v12622.r, v12650 / 2, v12651 / 2, v12652 / 2, {
            src: "model",
            asset: v12622.aid,
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            transparent: v12622.o != 1 && v12622.o != null,
            colr: v12622.c,
            noCol: v12622.l || v12622.col,
            noVis: v12622.v == null ? undefined : 1,
            noAmb: v12622.ab != null || undefined,
            interface: parseInt(v12622.in) || undefined,
            mSize: parseFloat(v12622.ms),
            noSmooth: v12622.txs != null || undefined,
            spin: parseFloat(v12622.spn || 0) || 0,
            spinAxis: parseInt(v12622.spa || 0) || 0,
            notWallJ: v12622.wj != null || undefined,
            noGrapple: v12622.gp != null || undefined,
            noShoot: v12622.ns != null || undefined,
            noAICol: v12622.nai != null || undefined,
            noImpulse: v12622.ip != null || undefined,
            cast: v12622.cst == null || undefined,
            receive: v12622.rcv == null || undefined,
            animS: parseFloat(v12622.as) || 0,
            startAnim: v12622.ast,
            forceRender: v12622.fcr != null || undefined,
            texEncode: parseInt(v12622.ten) || 0,
            alphaTest: parseFloat(v12622.alt || 0) || 0,
            noFog: v12622.nf != null || undefined,
            side: parseInt(v12622.rs) || 0,
            fTrans: v12622.ft != null || undefined,
            hbh: parseFloat(v12622.hbh) || 1,
            hbw: parseFloat(v12622.hbw) || 1,
            complexColl: v12622.cpx != null || undefined,
            noMinimap: v12622.smm != null || undefined
          });
        } else if (!p15670 || v12642.toUpperCase() != "EVENT") {
          this.manager.addMesh(v12647, v12648, v12649, v12622.r, v12650 / 2, v12651 / 2, v12652 / 2, {
            src: v12642.toLowerCase(),
            health: parseInt(v12622.h || v12622.hp) || 0,
            canDest: v12622.cdy != null || undefined,
            startDest: v12622.sd != null || undefined,
            spawnChance: parseFloat(v12622.rsc || 0) || 0,
            respawnT: (parseFloat(v12622.rt) || 0) * 1000,
            respawnR: v12622.rr != null || undefined,
            opacity: v12622.o != 1 && v12622.o != null ? v12622.o : 1,
            transparent: v12622.o != 1 && v12622.o != null,
            colr: v12622.c,
            noCol: v12622.l || v12622.col,
            noVis: v12622.v == null ? undefined : 1,
            noAmb: v12622.ab != null || undefined,
            interface: parseInt(v12622.in) || undefined,
            mSize: parseFloat(v12622.ms),
            spin: parseFloat(v12622.spn || 0) || 0,
            spinAxis: parseInt(v12622.spa || 0) || 0,
            notWallJ: v12622.wj != null || undefined,
            noGrapple: v12622.gp != null || undefined,
            noShoot: v12622.ns != null || undefined,
            noAICol: v12622.nai != null || undefined,
            noImpulse: v12622.ip != null || undefined,
            texEncode: parseInt(v12622.ten) || 0,
            texVar: parseInt(v12622.tv) || 0,
            sound: vParseInt47,
            noMinimap: v12622.smm != null || undefined
          });
        }
      }
      if (!p15672) {
        this.manager.addNoisePlanes();
      }
      if (this.terrain) {
        v12635.shadLength = this.terrain.sizeX * 1.2;
        v12635.shadWidth = this.terrain.sizeY * 1.2;
      } else {
        v12635.shadLength = Math.round(Math.abs(vLN02260 - vLN02259) / 2.5);
        v12635.shadWidth = Math.round(Math.abs(vLN02262 - vLN02261) / 2.5);
      }
      if (p15650) {
        p15650.updateLightMap(v12635);
      }
      this.manager.aoOpac = 0.5;
      var v12661 = p15650 && p15650.ambientShading && !p15650.isMobile && (p15650.groupData.oldAO || p15650.groupData.official || !p15650.groupData.hasLM && p15650.groupData.custom);
      if (v12661) {
        var v12662;
        var v12663 = config.ambScale;
        for (var vLN02278 = 0; vLN02278 < this.manager.objects.length; ++vLN02278) {
          v12622 = this.manager.objects[vLN02278];
          if (!v12622.noVis && (v12636.id != "prop" || !v12622.propID) && !v12622.complexMesh && !v12622.health && !v12622.canDest && !v12622.noAmb && !v12622.gate) {
            for (var v12664 = vLN02278 + 1; v12664 < this.manager.objects.length; ++v12664) {
              v12623 = this.manager.objects[v12664];
              if (!v12623.noVis && (v12636.id != "prop" || !v12623.propID) && !v12623.health && !v12623.canDest && !v12623.noAmb && !v12623.gate && !v12623.complexMesh && this.manager.collision(v12622, v12623, 0)) {
                v12662 = UTILS.boxIntersection(v12622, v12623, "x", "z", [Math.PI, 0, Math.PI / 2, -Math.PI / 2]);
                if (v12662) {
                  for (var vLN02275 = 0; vLN02275 < v12662.length; ++vLN02275) {
                    if (!v12662[vLN02275].dontUse) {
                      var v12679;
                      var v12677 = UTILS.getIntersection(v12622, v12623, "y");
                      var v12678 = v12663 * (v12622.aoMlt || 1) * (v12623.aoMlt || 1);
                      for (var vLN02277 = 0; vLN02277 < 2; vLN02277++) {
                        v12679 = (v12662[vLN02275].d + Math.PI / 2 * vLN02277) % (Math.PI * 2);
                        v12678 = Math.min(v12678, this.manager.limitAmb(v12663, v12662[vLN02275], v12679, "x", "z", v12622, v12623));
                      }
                      var v12679;
                      for (var vLN02277 = 0; vLN02277 < 2; vLN02277++) {
                        v12679 = (v12662[vLN02275].d + Math.PI / 2 * vLN02277) % (Math.PI * 2);
                        this.manager.addAmbient(v12662[vLN02275].x + v12678 * Math.cos(v12679), v12677.y, v12662[vLN02275].z + v12678 * Math.sin(v12679), -v12679 + Math.PI, 0, 0, v12677.height, v12678 + config.ambOff, 1);
                        if (v12679 == Math.PI / 2 || v12679 == -Math.PI / 2 || v12679 == Math.PI * 1.5) {
                          var v12681 = UTILS.limitRect(v12662[vLN02275].z + v12678 * Math.sin(v12679), v12677.y + v12678 + v12677.height + config.ambOff, v12678, v12678, 0, [v12622, v12623], "z", "y");
                          this.manager.addAmbient(v12662[vLN02275].x + v12678 * Math.cos(v12679), v12681.y, v12681.z, -v12679 + Math.PI, Math.PI, 0, v12681.length, v12681.height, 0, [v12622, v12623], "g1-" + vLN02277 + "-" + vLN02275, [v12662[vLN02275].x, v12677.y + v12677.height, v12662[vLN02275].z]);
                          v12681 = UTILS.limitRect(v12662[vLN02275].z + v12678 * Math.sin(v12679), v12677.y - v12678 - v12677.height - config.ambOff, v12678, v12678, 0, [v12622, v12623], "z", "y");
                          this.manager.addAmbient(v12662[vLN02275].x + v12678 * Math.cos(v12679), v12681.y, v12681.z, -v12679 + Math.PI, 0, 0, v12681.length, v12681.height, 0, [v12622, v12623], "g2-" + vLN02277 + "-" + vLN02275, [v12662[vLN02275].x, v12677.y - v12677.height, v12662[vLN02275].z]);
                        } else {
                          var v12681 = UTILS.limitRect(v12662[vLN02275].x + v12678 * Math.cos(v12679), v12677.y + v12678 + v12677.height + config.ambOff, v12678, v12678, 0, [v12622, v12623], "x", "y");
                          this.manager.addAmbient(v12681.x, v12681.y, v12662[vLN02275].z + v12678 * Math.sin(v12679), -v12679 + Math.PI, Math.PI, 0, v12681.width, v12681.height, 0, [v12622, v12623], "g1-" + vLN02277 + "-" + vLN02275, [v12662[vLN02275].x, v12677.y + v12677.height, v12662[vLN02275].z]);
                          v12681 = UTILS.limitRect(v12662[vLN02275].x + v12678 * Math.cos(v12679), v12677.y - v12678 - v12677.height - config.ambOff, v12678, v12678, 0, [v12622, v12623], "x", "y");
                          this.manager.addAmbient(v12681.x, v12681.y, v12662[vLN02275].z + v12678 * Math.sin(v12679), -v12679 + Math.PI, 0, 0, v12681.width, v12681.height, 0, [v12622, v12623], "g2-" + vLN02277 + "-" + vLN02275, [v12662[vLN02275].x, v12677.y - v12677.height, v12662[vLN02275].z]);
                        }
                      }
                    }
                  }
                }
                v12662 = UTILS.boxIntersection(v12622, v12623, "z", "y", [Math.PI, 0, -Math.PI / 2, Math.PI / 2]);
                if (v12662) {
                  for (var vLN02275 = 0; vLN02275 < v12662.length; ++vLN02275) {
                    if (!v12662[vLN02275].dontUse) {
                      var v12679;
                      var v12677 = UTILS.getIntersection(v12622, v12623, "x");
                      var v12678 = v12663 * (v12622.aoMlt || 1) * (v12623.aoMlt || 1);
                      for (var vLN02277 = 0; vLN02277 < 2; vLN02277++) {
                        v12679 = v12662[vLN02275].d + Math.PI / 2 * (vLN02277 ? 0 : 1);
                        v12678 = Math.min(v12678, this.manager.limitAmb(v12663, v12662[vLN02275], -v12679 + Math.PI / 2, "z", "y", v12622, v12623));
                      }
                      var v12679;
                      for (var vLN02277 = 0; vLN02277 < 2; vLN02277++) {
                        v12679 = v12662[vLN02275].d + Math.PI / 2 * (vLN02277 ? 0 : 1);
                        this.manager.addAmbient(v12677.x, v12662[vLN02275].y + v12678 * Math.cos(v12679), v12662[vLN02275].z + v12678 * Math.sin(v12679), 0, v12679, -Math.PI / 2, v12677.width, v12678 + config.ambOff, 1);
                        var v12681 = UTILS.limitRect(v12677.x + v12677.width + v12678 + config.ambOff, v12662[vLN02275].z + v12678 * Math.sin(v12679), v12678, v12678, 0, [v12622, v12623], "x", "z");
                        this.manager.addAmbient(v12681.x, v12662[vLN02275].y + v12678 * Math.cos(v12679), v12662[vLN02275].z + v12678 * Math.sin(v12679), Math.PI, v12679 == Math.PI ? v12679 : -v12679 % Math.PI, v12679 == Math.PI * 1.5 ? 0 : -Math.PI / 2, v12679 == Math.PI * 1.5 ? v12678 : v12681.length, v12679 == Math.PI * 1.5 ? v12681.length : v12678, 0, [v12622, v12623], "g3-" + vLN02277 + "-" + vLN02275, [v12677.x + v12677.width, v12662[vLN02275].y, v12662[vLN02275].z]);
                        v12681 = UTILS.limitRect(v12677.x - v12677.width - v12678 - config.ambOff, v12662[vLN02275].z + v12678 * Math.sin(v12679), v12678, v12678, Math.PI / 2, [v12622, v12623], "x", "z");
                        this.manager.addAmbient(v12681.x, v12662[vLN02275].y + v12678 * Math.cos(v12679), v12662[vLN02275].z + v12678 * Math.sin(v12679), Math.PI, -v12679 % Math.PI, v12679 == Math.PI || v12679 == Math.PI * 1.5 ? Math.PI / 2 : Math.PI, v12679 == Math.PI || v12679 == Math.PI * 1.5 ? v12681.width : v12678, v12679 == Math.PI || v12679 == Math.PI * 1.5 ? v12678 : v12681.width, 0, [v12622, v12623], "g4-" + vLN02277 + "-" + vLN02275, [v12677.x - v12677.width, v12662[vLN02275].y, v12662[vLN02275].z]);
                      }
                    }
                  }
                }
                v12662 = UTILS.boxIntersection(v12622, v12623, "x", "y", [Math.PI, 0, -Math.PI / 2, Math.PI / 2]);
                if (v12662) {
                  for (var vLN02275 = 0; vLN02275 < v12662.length; ++vLN02275) {
                    if (!v12662[vLN02275].dontUse) {
                      var v12679;
                      var v12677 = UTILS.getIntersection(v12622, v12623, "z");
                      var v12678 = v12663 * (v12622.aoMlt || 1) * (v12623.aoMlt || 1);
                      for (var vLN02277 = 0; vLN02277 < 2; vLN02277++) {
                        v12679 = v12662[vLN02275].d + Math.PI / 2 * (vLN02277 ? 0 : 1);
                        v12678 = Math.min(v12678, this.manager.limitAmb(v12663, v12662[vLN02275], -v12679 + Math.PI / 2, "x", "y", v12622, v12623));
                      }
                      var v12679;
                      for (var vLN02277 = 0; vLN02277 < 2; vLN02277++) {
                        v12679 = v12662[vLN02275].d + Math.PI / 2 * (vLN02277 ? 0 : 1);
                        this.manager.addAmbient(v12662[vLN02275].x + v12678 * Math.sin(v12679), v12662[vLN02275].y + v12678 * Math.cos(v12679), v12677.z, Math.PI / 2, v12679, -Math.PI / 2, v12677.length, v12678 + config.ambOff, 1);
                        if (v12679 == Math.PI || v12679 == 0) {
                          var v12681 = UTILS.limitRect(v12662[vLN02275].z + v12678 * Math.sin(v12679), v12677.z + v12677.length + v12678 + config.ambOff, v12678, v12678, Math.PI / 2, [v12622, v12623], "x", "z");
                          this.manager.addAmbient(v12662[vLN02275].x + v12678 * Math.sin(v12679), v12662[vLN02275].y + v12678 * Math.cos(v12679), v12681.z, Math.PI / 2, v12679, -Math.PI / 2, v12681.length, v12681.width, 0, [v12622, v12623], "g5-" + vLN02277 + "-" + vLN02275, [v12662[vLN02275].x, v12662[vLN02275].y, v12677.z + v12677.length]);
                          v12681 = UTILS.limitRect(v12662[vLN02275].z + v12678 * Math.sin(v12679), v12677.z - v12677.length - v12678 - config.ambOff, v12678, v12678, Math.PI / 2, [v12622, v12623], "x", "z");
                          this.manager.addAmbient(v12662[vLN02275].x + v12678 * Math.sin(v12679), v12662[vLN02275].y + v12678 * Math.cos(v12679), v12681.z, Math.PI / 2, v12679, Math.PI, v12681.width, v12681.length, 0, [v12622, v12623], "g6-" + vLN02277 + "-" + vLN02275, [v12662[vLN02275].x, v12662[vLN02275].y, v12677.z - v12677.length]);
                        } else {
                          var v12681 = UTILS.limitRect(v12662[vLN02275].x + v12678 * Math.sin(v12679), v12677.z + v12677.length + v12678 + config.ambOff, v12678, v12678, Math.PI / 2, [v12622, v12623], "x", "z");
                          this.manager.addAmbient(v12681.x, v12662[vLN02275].y + v12678 * Math.cos(v12679), v12681.z, Math.PI / 2, v12679, -Math.PI / 2, v12681.length, v12681.width, 0, [v12622, v12623], "g5-" + vLN02277 + "-" + vLN02275, [v12662[vLN02275].x, v12662[vLN02275].y, v12677.z + v12677.length]);
                          v12681 = UTILS.limitRect(v12662[vLN02275].x + v12678 * Math.sin(v12679), v12677.z - v12677.length - v12678 - config.ambOff, v12678, v12678, Math.PI / 2, [v12622, v12623], "x", "z");
                          this.manager.addAmbient(v12681.x, v12662[vLN02275].y + v12678 * Math.cos(v12679), v12681.z, Math.PI / 2, v12679, Math.PI, v12681.width, v12681.length, 0, [v12622, v12623], "g6-" + vLN02277 + "-" + vLN02275, [v12662[vLN02275].x, v12662[vLN02275].y, v12677.z - v12677.length]);
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        this.manager.addPendingAOs();
      }
      this.manager.pendingTriangles.length = 0;
      if (v12635.tris && Array.isArray(v12635.tris) && v12635.tris.length) {
        this.manager.pendingTriangles = v12635.tris;
      }
      this.manager.genQuads();
      this.spawns.length = 0;
      var v12682;
      for (var vLN02278 = 0; vLN02278 < v12635.spawns.length; ++vLN02278) {
        v12682 = parseFloat(v12635.spawns[vLN02278][7]) || 0;
        this.spawns.push({
          x: v12635.spawns[vLN02278][0],
          y: v12635.spawns[vLN02278][1],
          z: v12635.spawns[vLN02278][2],
          team: v12635.spawns[vLN02278][3],
          dir: parseInt(v12635.spawns[vLN02278][4]) || 0,
          comp: !!v12635.spawns[vLN02278][5] || !true,
          teamOnly: !!v12635.spawns[vLN02278][6] || !true,
          spread: UTILS.limitMM(v12682, 0, 50)
        });
      }
      if (p15650) {
        p15650.addMeshGroups();
        p15650.finalizeInstanceGroups();
      }
    }
    this.finishGenerate(p15668);
  };
  this.finishGenerate = function () {};
};
function f2097(p15673, p15674, p15675, p15676 = {}) {
  for (var v12683 in p15675) {
    var v12684;
    var v12685 = p15674[v12683];
    var v12686 = p15675[v12683];
    if (v12686.props) {
      v12684 = f2097(p15673, v12685, v12686.props, p15676[v12683]);
    } else if (v12686.isMapObject) {
      v12684 = f2098(p15673, v12685);
    } else if (v12686.isTerrainConfig) {
      if (v12685) {
        p15676.terrain = Terrain.fromConfig(v12685);
        p15676.terrain.rotation.x = -Math.PI / 2;
        v12684 = v12685;
      } else {
        v12684 = null;
      }
    } else if (v12686.isZoneConfig) {
      if (v12685) {
        p15676.zone = Zone.fromConfig(v12685);
        v12684 = v12685;
      } else {
        v12684 = null;
      }
    } else {
      if (v12683 == "maps" && !p15676.changedMaps) {
        continue;
      }
      v12684 = v12685;
    }
    p15676[v12683] = v12684;
  }
  return p15676;
}
function f2098(p15677, p15678) {
  if (p15678 && p15678.isTri) {
    return Triangle.fromConfig(p15678);
  }
  if (Array.isArray(p15678)) {
    return p15678.map(p15679 => f2098(p15677, p15679));
  }
  if (typeof p15678 == "object") {
    var vO405 = {};
    for (var v12687 in p15678) {
      vO405[v12687] = f2098(p15677, p15678[v12687]);
    }
    return vO405;
  }
  return p15677.mapObjects[p15678];
}
function f2099(p15680, p15681, p15682) {
  return p15680 + (p15681.genID == null ? "" : "_" + p15681.genID) + (p15682 ? "_e" + p15682 : "");
}